import React, { useEffect, useState } from 'react';
import { useGetGradeAssessmentsMutation } from '../../../../features/authentication/assessmentApiSlice';
import { PieChart } from 'react-minimal-pie-chart';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import QuestionPreviewModal from '../../components/QuestionPreviewModal';
import SkeletonGrid from '../../../../components/SkeletonLoader/SkeletonGrid';
import TableSkeleton from '../../../../components/SkeletonLoader/TableSkeleton';
import SortButtons from '../../../../components/SortButtons/index';
import { ResourceUtils } from '../../components/questionDetailComponents/ResourceUtils';
import { useNavigate } from 'react-router';

const GradeAssessmentList = () => {
  const limit = 30;
  const [skipValue, setSkipValue] = useState(0);
  const [selectedAssessmentId, setSelectedAssessmentId] = useState(0);
  const [selectedQuestionId, setSelectedQuestionId] = useState(0);
  const [total, setTotal] = useState(0);
  const [openPreviewModal, setOpenPreviewModal] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [intialLoading, setInitialLoading] = useState(false);
  const [gradeAssessments, setGradeAssessments] = useState([]);
  const [sortId, setSortId] = useState('assessmentName');
  const [isAscending, setIsAscending] = useState(true);
  const [getGradeAssessments] = useGetGradeAssessmentsMutation();
  const navigate = useNavigate();

  const previewOptions ={
    hidePrint: true,
    showHtmResources :true
  };
  
  useEffect(() => {
    setInitialLoading(true);
    getGradeAssessmentsAsync(skipValue, limit);
  }, []);

  const getGradeAssessmentsAsync = async (skip, take) => {
    const options = {
      skip: skip,
      take: take
    };
    var response = await getGradeAssessments(options).unwrap();
    let data = [...gradeAssessments, ...response.data];
    setGradeAssessments(data);
    setTotal(response.total);
    setInitialLoading(false);
  };

  const nextCallback = async (newOffset) => {
    setIsLoadingMore(true);
    setSkipValue(newOffset);
    getGradeAssessmentsAsync(newOffset, limit);
    setIsLoadingMore(false);
  };

  const handleQuestionClick = (assessmentId, questionId) => {
    setSelectedAssessmentId(assessmentId);
    setSelectedQuestionId(questionId);
    setOpenPreviewModal(true);
  };

  const handleSort = async (currentSortId) => {
    let sortAsc = true;
    if (currentSortId === sortId)
      sortAsc = !isAscending;
    setSortId(currentSortId);

    let sortedStudents = await ResourceUtils.customSort(gradeAssessments, currentSortId, sortAsc);
    setGradeAssessments(sortedStudents);
    setIsAscending(sortAsc);
  };

  return (
    <>
      <div className='white-card'>
        {intialLoading ? 
          (<>
            <SkeletonGrid
              rowCount={1}
              colCount={1}
              className='p-3 mb-4'/>
            <TableSkeleton
              rowCount={4}
              colCount={6}
              skeletonClass='p-1 mt-3 mb-3'/>
          </>):(
            <>
              <div className='d-flex justify-content-between align-items-center'> 
                <h5>{`Assessment Grading (${total})`}</h5>
                <div>
                  <button className='btn btn-castleWhite btn-width' onClick={()=>window.history.back()}>Back</button>
                </div>
              </div>
       
              <InfiniteScroll
                dataLength={gradeAssessments.length}
                next={() => nextCallback(skipValue + limit)}
                hasMore={(total / (skipValue + limit)) > 1}
                scrollableTarget='scrollableDiv'
              >
                <div id='scrollableDiv' className='assignments-scroll-bar max-h-550 custom-table table-responsive mt-5' style={{ overflowY: 'auto' }}>
                  <table className='table reportTable'>
                    <thead className='thead-light align-middle'>
                      <tr>
                        <th scope="col" className='cursor-pointer fw-medium' onClick={() => handleSort('assessmentName')}>
                          Assessment Name
                          <SortButtons
                            selectedSortId={sortId}
                            elementSortId={'assessmentName'}
                            isAscending={isAscending}
                          />
                        </th>
                        <th scope="col" className='cursor-pointer fw-medium' onClick={() => handleSort('owner')}>
                          Owner
                          <SortButtons
                            selectedSortId={sortId}
                            elementSortId={'owner'}
                            isAscending={isAscending}
                          />
                        </th>
                        <th scope="col" className='cursor-pointer fw-medium' onClick={() => handleSort('questionCount')}>
                          Questions
                          <SortButtons
                            selectedSortId={sortId}
                            elementSortId={'questionCount'}
                            isAscending={isAscending}
                          />
                        </th>
                        <th scope="col" className='cursor-pointer fw-medium text-center min-w-160' onClick={() => handleSort('assigned')}>
                          Assigned Count
                          <SortButtons
                            selectedSortId={sortId}
                            elementSortId={'assigned'}
                            isAscending={isAscending}
                          />
                        </th>
                        <th scope="col" className='cursor-pointer fw-medium'>
                          Progress
                        </th>
                        <th scope="col">
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {gradeAssessments.map((assessment, index) => (
                        <tr key={index}>
                          <td>
                            {assessment.name}
                          </td>
                          <td>
                            {assessment.owner}
                          </td>
                          <td>
                            <ul className="d-flex flex-wrap gap-2 p-0">
                              {assessment.questions?.map((question, qindex) => {
                                return (
                                  <li
                                    key={qindex}
                                    onClick={() => handleQuestionClick(assessment.id,question.questionId)}
                                    className={`question-list-item ${assessment.isGradingAvailable ? 'cursor-pointer' : 'disable-Pointer-Events text-grey'}`}>
                                    <a>{question.questionIndex + 1}</a>
                                  </li>
                                );
                              })}
                            </ul>
                          </td>
                          <td className='text-center min-w-160'>
                            {assessment.assigned}
                          </td>
                          <td>
                            <div className='d-flex'>
                              <div>
                                <PieChart
                                  data={[
                                    {title:`${assessment.ungraded} Ungraded`, value: assessment.ungraded, color: '#FB7F7F' },
                                    {title:`${assessment.graded} Graded`, value: assessment.graded, color: '#52C9A5' },
                                    {title:`${assessment.unanswered} Unanswered`, value: assessment.unanswered, color: '#FFC27A' },
                                  ]}
                                  lineWidth={40}
                                  startAngle={270}
                                  style={{ height: '85px' }}
                                />
                              </div>
                              <div className='text-start mx-4'>
                                <p><label className='fw-semibold'>{assessment.ungraded}</label> Ungraded</p>
                                <p><label className='fw-semibold'>{assessment.graded}</label> Graded</p>
                                <p><label className='fw-semibold'>{assessment.unanswered}</label> Unanswered</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <>
                              {assessment.isGradingAvailable ? (
                                <button className='btn btn-castleRed' onClick={() => navigate(`${assessment.id}`)}>Start Grading</button>
                              ) : (
                                <div>Not Available</div>
                              )}
                            </>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </InfiniteScroll>

              {isLoadingMore && (
                <div className='mt-3 text-center fs-4'>
                  <FontAwesomeIcon icon={faSpinner} spin /><span className='ms-2'></span>
                </div>
              )}
            </>
          )}

        {openPreviewModal &&
        <QuestionPreviewModal
          assignmentId={selectedAssessmentId}
          questionId={selectedQuestionId}
          isOpen={openPreviewModal}
          onClose={() => setOpenPreviewModal(false)}
          previewOptions={previewOptions}
        />
        }
      </div>
    </>
  );
};

export default GradeAssessmentList;
